import { FormProps } from '#/store/hooks/useForms/types'
import { listeners } from '#/utils/listeners'

const pagebuilderForms = {
  page_builder: {
    action: ({ afterSuccess, params }: FormProps) => {
      return {
        ...params,
        afterSuccess: data => {
          window.dispatchEvent(new Event(listeners.pagebuilder))
          afterSuccess?.(data)
        },
      }
    },
  },
}

export { pagebuilderForms }
